import { render, staticRenderFns } from "./lucky.vue?vue&type=template&id=291096ac&scoped=true&"
import script from "./lucky.vue?vue&type=script&lang=js&"
export * from "./lucky.vue?vue&type=script&lang=js&"
import style0 from "./lucky.vue?vue&type=style&index=0&id=291096ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291096ac",
  null
  
)

export default component.exports